(function(window, undefined) {
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.schema', ['ngSanitize', 'schemaForm']);
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.schema').directive('ecSchema', ecSchema);
    /** @ngInject **/
    function ecSchema() {
      var directive = {
        restrict: 'E',
        scope: {
          component: '=',
        },
        link: link,
        controller: SchemaController,
        controllerAs: 'vm',
        templateUrl: '/app/vendor/ec-fe-bo-template/dist/views/schema/schema.html',
      };
      return directive;
      function link(scope, elem, atrrs, controller) {
        elem.find('form').on('focusout', saveSchema);
        elem.on('$destroy', function() {
          elem.find('form').off('focusout', saveSchema);
        });
        function saveSchema() {
          controller.saveForm();
        }
      }
    }
    /** @ngInject **/
    function SchemaController($scope) {
      var vm = this;
      //TODO figure out why bind to controller is not working
      vm.component = $scope.component;
      vm.schema = $scope.component.schema;
      vm.model = $scope.component.model;
      vm.latestModel = angular.copy(vm.model);
      vm.form = ['*'];
      vm.schemaForm = {};
      vm.saveForm = saveForm;
      vm.validateForm = validateForm;
      function saveForm() {
        validateForm();
        if (vm.schemaForm.$valid && !angular.equals(vm.latestModel, vm.model)) {
          vm.latestModel = angular.copy(vm.model);
          $scope.$emit('schema.update-schema');
        }
      }
      function validateForm() {
        $scope.$broadcast('schemaFormValidate');
        if (!vm.schemaForm.$valid) {
          $scope.$emit('schema.add-invalid-component', {
            component: vm.component,
          });
        } else {
          $scope.$emit('schema.remove-invalid-component', {
            component: vm.component,
          });
        }
      }
    }
    SchemaController.$inject = ['$scope'];
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.schema').directive('ecSchemaHeader', ecSchemaHeader);
    /** @ngInject **/
    function ecSchemaHeader() {
      return {
        restrict: 'E',
        scope: {
          schema: '=',
        },
        controller: SchemaHeaderController,
        controllerAs: 'vm',
        templateUrl: '/app/vendor/ec-fe-bo-template/dist/views/schema/schema.header.html',
      };
    }
    /** @ngInject **/
    function SchemaHeaderController($scope) {
      var vm = this;
      vm.schema = $scope.schema;
      vm.index = $scope.index;
      vm.addComponent = addComponent;
      vm.removeComponent = removeComponent;
      function addComponent(event) {
        handleEvent(event);
        $scope.$emit('schema.add-component', {
          schema: vm.schema,
        });
      }
      function removeComponent(event) {
        handleEvent(event);
        $scope.$emit('schema.remove-component', {
          schema: vm.schema,
        });
      }
      function handleEvent(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }
    SchemaHeaderController.$inject = ['$scope'];
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.schema').directive('ecSchemas', ecSchemas);
    /** @ngInject **/
    function ecSchemas() {
      var directive = {
        restrict: 'E',
        scope: {
          components: '=',
        },
        templateUrl: '/app/vendor/ec-fe-bo-template/dist/views/schema/schemas.html',
      };
      return directive;
    }
  })();
})(window, undefined);



// WEBPACK FOOTER //
// ./src/app/vendor/ec-fe-bo-template/dist/schema/schema.max.js